import { z, ZodType } from 'zod'

import { adUnitsAttributesSchema } from 'features/inventory/domain/components/ProductAdUnitsTable'
import { Domain } from 'features/inventory/types/domain'
import {
  UnfilledRecoveryPrebidBehaviour,
  unfilledRecoveryPrebidBehaviours,
} from 'features/inventory/types/unfilledRecoveryPrebidBehaviour'

export const unfilledRecoveryEnabled: ZodType<boolean> = z.boolean()
export const prebidBehaviourType: ZodType<UnfilledRecoveryPrebidBehaviour> = z
  .enum(unfilledRecoveryPrebidBehaviours)
  .default('disabled')

export const schema = z
  .object({
    baseAdUnitPath: z.string().optional(),
    domainId: z.string(),
    prebidBehaviourType,
    unfilledRecoveryEnabled,
  })
  .extend(adUnitsAttributesSchema.shape)

export const schemaDefault = ({
  domainUnfilledRecovery: { baseAdUnitPath, prebidBehaviourType },
  id,
  unfilledRecoveryEnabled,
}: Domain): Schema => ({
  adUnitsAttributes: {},
  baseAdUnitPath,
  domainId: id,
  prebidBehaviourType,
  unfilledRecoveryEnabled,
})

export type Schema = z.infer<typeof schema>
